export default __webpack_public_path__ + "static/media/18t.1d69c78c.jpg";